import { POST_TYPE } from '../../post/model/constants'
import POSTS_PATH from './path'

const POST_TYPE_TO_DOMAIN_LIST_PATH = {
  [POST_TYPE.WORKOUT_LOGGED]: POSTS_PATH.WORKOUTS_LOGGED,
  [POST_TYPE.PLAN_LOGGED]: POSTS_PATH.PLANS_LOGGED,
  [POST_TYPE.ARTICLE]: POSTS_PATH.ARTICLES
}

export default POST_TYPE_TO_DOMAIN_LIST_PATH
